import { useDispatch, useSelector } from 'react-redux';
import { signOut } from '../../../store/actions/users';

export default function TopBar() {
  const dispatch = useDispatch();
  const { data } = useSelector(state => state.users);

  const initials = `${data?.name?.[0] ?? ''}${data?.surname?.[0] ?? ''}`.toUpperCase();

  return (
    <header className="adm-topbar">
      <div className="adm-topbar-spacer" />
      <div className="adm-topbar-right">
        <div className="adm-user">
          <div className="adm-avatar" aria-hidden="true">{initials}</div>
          <div className="adm-user-info">
            <span className="adm-user-name">{data?.name} {data?.surname}</span>
            <span className="adm-user-role">Administrátor</span>
          </div>
        </div>
        <button className="adm-logout-btn" onClick={() => dispatch(signOut())} aria-label="Odhlásiť sa">
          Odhlásiť sa
        </button>
      </div>
    </header>
  );
}
